import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import LanguageSelector from './LanguageSelector';

const Hero = ({ onCtaClick }) => {
  const { t } = useTranslation();
  
  return (
    <div className="relative min-h-screen flex flex-col bg-dark-bg">
      {/* Animated Marquee */}
      <div className="w-full bg-burgundy py-4 overflow-hidden border-b-2 border-cream-gold">
        <div className="marquee-container">
          <div className="marquee-content">
            {[...Array(12)].map((_, i) => (
              <span key={i} className="marquee-item text-cream-gold font-bold text-xl tracking-widest mx-8">
                {t('hero.marqueeText')}
              </span>
            ))}
          </div>
        </div>
      </div>
      
      {/* Language Selector - Positioned below marquee */}
      <div className="absolute top-20 right-6 z-50">
        <LanguageSelector />
      </div>

      {/* Hero Content */}
      <div className="flex-1 flex items-center justify-center px-6 py-20 bg-gradient-to-b from-dark-bg via-burgundy-darkest to-burgundy-darker">
        <div className="max-w-5xl mx-auto text-center space-y-8">
          <div className="space-y-4 animate-fade-in">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold bg-gradient-to-r from-cream-gold via-cream-gold-light to-cream-gold bg-clip-text text-transparent leading-tight drop-shadow-2xl">
              {t('hero.headline')}
            </h1>
            <p className="text-xl md:text-2xl text-cream-gold-light/90 max-w-3xl mx-auto leading-relaxed">
              {t('hero.subheadline')}
            </p>
          </div>
          
          <div className="pt-6 animate-fade-in-delay">
            <Button 
              onClick={onCtaClick}
              className="bg-gradient-to-r from-cream-gold to-cream-gold-dark hover:from-cream-gold-dark hover:to-cream-gold text-burgundy-darkest px-10 py-7 text-lg font-bold rounded-full transition-all duration-300 hover:scale-110 hover:shadow-2xl shadow-cream-gold/50 group"
            >
              {t('hero.ctaText')}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-cream-gold rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-cream-gold rounded-full animate-scroll"></div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
